/* eslint-disable prettier/prettier */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from "@techsoftware/happay-widgets/Grid";
import Button from "@techsoftware/happay-widgets/Button";
import Dialog from '@techsoftware/happay-widgets/DialogBox';
import {HDFC_ACC , RBL_ACC} from '../../constants/bankAccDetails';
export default class PaymentInfo extends Component {
  drawBankAccountDetails() {
    let uiEleArr = [];
    const { accData } = this.props;
    if(accData && accData.length){
      accData.forEach((item)=>{
        const itemEle = this.setPaymentObjUI(item); 
        uiEleArr = [...uiEleArr,...itemEle];
        uiEleArr.push(
          <hr className='border-b border-color dark'></hr>
        )
      })
    }else{
      uiEleArr = this.setPaymentObjUI({});
    }
    return uiEleArr;
  }

  setPaymentObjUI(item) {
    const uiIem = [];
    let details = {}
    const accObj = item;
    if(accObj.bank_name && accObj.bank_name.includes("HDFC")){
      details = HDFC_ACC
    }else{
      details = RBL_ACC
    }
    if ('branch_name' in accObj) {
      details.branch.value = accObj.branch_name;
    }
    if ('bank_address' in accObj) {
      details.address.value = accObj.bank_address;
    }
    for (const key in details) {
      const ele = (
        <Grid key={key} container xs={24} alignItems='flex-start' className="padding-tb-8">
          <Grid item xs={8} className="info-text regular">
            {details[key].name}
          </Grid>
          <Grid item xs={2}>
            :
          </Grid>
          <Grid
            key={details[key].value}
            item
            xs={12}
            className="body dark fw-500"
          >
            {details[key].value
              ? details[key].value
              : accObj
                ? accObj[key]
                : ''}
          </Grid>
        </Grid>
      );
      uiIem.push(ele);
    }
    return uiIem;
  }

  render() {
    return (
      <Dialog
        open={this.props.open}
        dialogTitleContainerStyle={{padding:'30px 30px'}}
        id='paymentInfoDialog'
        onClose={() => {
          this.props.onPayInfoClose(false);
        }}
        // fullWidth
        width="600px"
        bodyStyle={{padding:'0px 30px'}}
        // maxWidth="sm"
        title={<div title="Bank account">Beneficiary account details</div>}
        actions={
          <>
            {/* <div
              className="status green pointer fw-700 font-16 margin-l-10"
              onClick={() => {
                this.props.onPayInfoClose(false);
              }}
            >
              Ok, got it
            </div> */}
            <Button
              type="button"
              text="Ok, got it"
              variant="tertiary"
              size="medium"
              // buttonParentStyles={{ padding: '10px 22px' }}
              // className="btn-view-details bill-view"
              onClick={()=>{
                this.props.onPayInfoClose(false);
              }}
            />
          </>
        }
      >
        <Grid>
          <Grid container>
            <Grid item xs={24} className="body padding-b-8 padding-t-4">
              Please transfer the amount you want to pay Happay to the following
              bank account :
            </Grid>
            {this.drawBankAccountDetails()}
            <Grid item xs={24} className="body padding-t-16">
              On successful transfer, the payment will reflect under payments
              tab in Bill section .
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    );
  }
}

PaymentInfo.propTypes = {
  open: PropTypes.bool,
  onPayInfoClose: PropTypes.func,
  accData: PropTypes.object,
};

PaymentInfo.defaultProps = {
  open: false,
  accData: {},
};
